import React from 'react';
import './FileProcessingStatus.css';

const FileProcessingStatus = ({ processingFiles, onRemoveFile }) => {
  if (!processingFiles || processingFiles.length === 0) {
    return null;
  }

  const getStatusIcon = (status) => {
    switch (status) {
      case 'uploading':
        return '⬆️';
      case 'accepted':
        return '⏳';
      case 'queued':
        return '⏳';
      case 'active':
        return '🔄';
      case 'completed':
        return '✅';
      case 'failed':
        return '❌';
      default:
        return '📄';
    }
  };

  const getStatusText = (file) => {
    switch (file.status) {
      case 'uploading':
        return `Загрузка... ${file.progress || 0}%`;
      case 'accepted':
        return 'Принят в обработку';
      case 'queued':
        return 'В очереди';
      case 'active':
        return `${file.stage || 'Обрабатывается'} ${file.progress || 0}%`;
      case 'completed':
        return 'Обработан';
      case 'failed':
        return `Ошибка: ${file.error || 'Неизвестная ошибка'}`;
      default:
        return file.message || 'Неизвестный статус';
    }
  };

  const formatFileSize = (bytes) => {
    if (!bytes) return '';
    const k = 1024;
    const sizes = ['Байт', 'КБ', 'МБ', 'ГБ'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  return (
    <div className="file-processing-status">
      <div className="status-header">
        <span className="status-title">📂 Обработка файлов</span>
        <span className="status-count">{processingFiles.length}</span>
      </div>
      
      <div className="status-list">
        {processingFiles.map((file) => (
          <div 
            key={file.id || file.jobId} 
            className={`status-item ${file.status}`}
          >
            <div className="status-icon">
              {getStatusIcon(file.status)}
            </div>
            
            <div className="status-content">
              <div className="file-name" title={file.name}>
                {file.name}
              </div>
              <div className="file-details">
                <span className="file-size">{formatFileSize(file.size)}</span>
                <span className="file-status">{getStatusText(file)}</span>
              </div>
              
              {(file.status === 'active' || file.status === 'uploading') && file.progress > 0 && (
                <div className="progress-bar">
                  <div 
                    className="progress-fill"
                    style={{ width: `${file.progress}%` }}
                  />
                </div>
              )}

              {file.status === 'uploading' && (
                <button 
                  className="remove-button"
                  onClick={() => onRemoveFile && onRemoveFile(file.id)}
                  title="Отменить загрузку"
                >
                  ×
                </button>
              )}
            </div>
            
            {(file.status === 'completed' || file.status === 'failed') && onRemoveFile && (
              <button 
                className="remove-button"
                onClick={() => onRemoveFile(file.id || file.jobId)}
                title="Убрать из списка"
              >
                ×
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FileProcessingStatus; 